import { styled, useTheme } from "@mui/material/styles";

import { Typography } from "@/components/ui-v2";
import { SafetensorsIcon } from "@/components/ui-v2/icons";

import { TileObjectTypeIndicator } from "../common/TileObjectTypeIndicator";
import {
  classes as TileClasses,
  TileBase,
  TileBaseProps,
} from "../TileBase/TileBase";

const StyledTileBase = styled(TileBase)(({ theme }) => ({
  flexDirection: "column",
  gap: theme.spacing(2),
  [`& .${TileClasses.bottomLeftEl}`]: {
    transition: "opacity 0.2s ease-in-out",
    opacity: 0,
  },
  "&:hover": {
    [`& .${TileClasses.bottomLeftEl}`]: {
      opacity: 1,
    },
  },
}));

export const SafeTensorsTile = (props: TileBaseProps) => {
  const { title, slots, slotProps, ...rest } = props;
  const theme = useTheme();

  return (
    <StyledTileBase
      sx={{ background: theme.palette.secondary[6] }}
      slots={{
        ...slots,
        topLeftEl: TileObjectTypeIndicator,
      }}
      slotProps={{
        ...slotProps,
        topLeftEl: {
          objectType: "safetensors",
        },
      }}
      {...rest}
    >
      <SafetensorsIcon sx={{ width: 42, height: 42 }} />
      <Typography variant="regular">{title}</Typography>
    </StyledTileBase>
  );
};
